import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { vehicleTypeColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';
import type { ApiVehicleType } from '@Model';
import { EnumFrontendLayoutSetting } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { VehicleTypesRepository } from '@Repositories/Stammdaten';

export function FrameListVehicleType() {
    const hasPermission = useHasPermission();

    const module = useListApi(VehicleTypesRepository, STAMMDATEN_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiVehicleType>
            layoutSettingsContext={EnumFrontendLayoutSetting.VehicleTypesTableLayout}
            name="VehicleTypeList"
            columns={vehicleTypeColumns}
            loader={module.loadPage}
            canCreate={hasPermission(Permission.StammdatenVehicleTypeCreate)}
            useOnClickNavigation
            fullSize
        />
    );
}
